import React from "react"
import { ButtonLinkList } from "../../common/button-link"
import { StyledContainer, StyledDescription, StyledHeading, StyledLabel } from "./item-content.styles"

export const ItemContent = ({ className, label, heading, description, links }: { className?: string, label?: string, heading: string, description?: string, links?: any[] }) => {
  return (
    <StyledContainer className={className}>
      {label && <StyledLabel>{label}</StyledLabel>}
      <StyledHeading>{heading}</StyledHeading>
      {description && <StyledDescription>{description}</StyledDescription>}
      {links && <ButtonLinkList links={links} variant="outline" />}
    </StyledContainer>
  )
}